import { render, staticRenderFns } from "./vaccins-data.vue?vue&type=template&id=78319fe2"
import script from "./vaccins-data.vue?vue&type=script&lang=js"
export * from "./vaccins-data.vue?vue&type=script&lang=js"
import style0 from "./vaccins-data.vue?vue&type=style&index=0&id=78319fe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports